const PAXG = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#a)">
      <path
        d="M5.28 3.344c.36-.414.694-.764 1.01-1.06C.942 2.11 2.5 5.993.747 9.935c-2.006 4.544.238 6.275 3.58 6.816a7.31 7.31 0 0 1-1.13-1.856C1.04 12.158 1.914 7.166 5.279 3.343Z"
        fill="#EFE812"
      />
      <path
        d="M18.147 8.184a15.355 15.355 0 0 1-2.7 4.541 12.976 12.976 0 0 1-3.281 2.855 8.83 8.83 0 0 1-4.841 1.381c-1 .01-2-.06-2.988-.209a6.113 6.113 0 0 0 1.998 1.572c4.836 2.349 5.14-2.012 10.255-4.226 2.872-1.243 2.883-3.671 1.555-5.914M12.166 3.65c.7.124 1.375.364 1.996.711a11.151 11.151 0 0 1 3.986 3.823c.87-2.465.464-4.4-1.44-4.75-2.095-.385-3.731-.51-5.305-1.612C9.466.47 7.766.91 6.293 2.286l.32.013c2.042.122 3.996.53 5.543 1.347"
        fill="#EDE70A"
      />
      <path
        d="M5.279 3.343c-3.365 3.823-4.24 8.815-2.072 11.553a8.345 8.345 0 0 1 .467-7.422C5.498 4.42 9.16 3.094 12.166 3.65c-1.558-.827-3.51-1.225-5.543-1.347l-.32-.016c-.327.303-.66.642-1.024 1.055Z"
        fill="#DEC21C"
      />
      <path
        d="M14.162 4.356a6.336 6.336 0 0 0-1.996-.705c2.048 1.082 3.408 2.916 3.408 5.816a7.323 7.323 0 0 1-.926 3.494 7.286 7.286 0 0 1-2.482 2.62 12.92 12.92 0 0 0 3.281-2.856 15.353 15.353 0 0 0 2.7-4.54 11.152 11.152 0 0 0-3.985-3.829"
        fill="#E5CB22"
      />
      <path
        d="M12.166 3.651c-3.007-.557-6.668.769-8.492 3.81a8.331 8.331 0 0 0-.467 7.435 7.237 7.237 0 0 0 1.13 1.856c.989.149 1.988.219 2.988.21a8.831 8.831 0 0 0 4.84-1.382 7.282 7.282 0 0 0 2.483-2.619 7.321 7.321 0 0 0 .926-3.494c0-2.9-1.36-4.734-3.408-5.816Zm-.338 10.55a4.981 4.981 0 0 1-3.753.685 5 5 0 0 1-3.142-2.174C3.44 10.398 4.178 7.41 6.42 5.819c2.508-1.789 5.723-1.084 6.895 1.49 1.143 2.508.829 5.406-1.486 6.893"
        fill="#CCA727"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 1)" d="M0 0h19v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default PAXG;
